module.exports = __webpack_public_path__ + "img/13_001.21252723.webp";